/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as AppRouteImport } from "./routes/_app";
import { Route as StaffRouteImport } from "./routes/_staff";
import { Route as ConnectRouteImport } from "./routes/connect";
import { Route as InviteRouteImport } from "./routes/invite";
import { Route as SharedRouteImport } from "./routes/shared";
import { Route as SignInRouteImport } from "./routes/sign-in";
import { Route as AppIndexRouteImport } from "./routes/_app/index";
import { Route as AppSplatRouteImport } from "./routes/_app/$";
import { Route as AppActivityRouteImport } from "./routes/_app/activity";
import { Route as AppDataRouteImport } from "./routes/_app/data";
import { Route as AppLearnedRouteImport } from "./routes/_app/learned";
import { Route as AppListsRouteImport } from "./routes/_app/lists";
import { Route as AppRoutinesRouteImport } from "./routes/_app/routines";
import { Route as AppSettingsRouteImport } from "./routes/_app/settings";
import { Route as AppStaffAccessRouteImport } from "./routes/_app/staff-access";
import { Route as AppStudyRouteImport } from "./routes/_app/study";
import { Route as AppTimelineRouteImport } from "./routes/_app/timeline";
import { Route as AppUnderstandingRouteImport } from "./routes/_app/understanding";
import { Route as CompanyDeleteRouteImport } from "./routes/company.delete";
import { Route as CompanyRestoreRouteImport } from "./routes/company.restore";
import { Route as AppAreasGroupIdRouteImport } from "./routes/_app/areas.$groupId";
import { Route as AppConfirmIndexRouteImport } from "./routes/_app/confirm.index";
import { Route as AppConfirmRequestIdRouteImport } from "./routes/_app/confirm.$requestId";
import { Route as AppConnectPlatformRouteImport } from "./routes/_app/connect.$platform";
import { Route as AppInsightsIndexRouteImport } from "./routes/_app/insights.index";
import { Route as AppInsightsInsightIdRouteImport } from "./routes/_app/insights.$insightId";
import { Route as AppInsightsPlaybooksRouteImport } from "./routes/_app/insights.playbooks";
import { Route as AppListsIndexRouteImport } from "./routes/_app/lists.index";
import { Route as AppListsListIdRouteImport } from "./routes/_app/lists.$listId";
import { Route as AppMeasuresIndexRouteImport } from "./routes/_app/measures.index";
import { Route as AppMeasuresRecipeIdRouteImport } from "./routes/_app/measures.$recipeId";
import { Route as AppPagesIndexRouteImport } from "./routes/_app/pages.index";
import { Route as AppPagesPageIdRouteImport } from "./routes/_app/pages.$pageId";
import { Route as AppSettingsIndexRouteImport } from "./routes/_app/settings.index";
import { Route as AppSettingsAccessRouteImport } from "./routes/_app/settings.access";
import { Route as AppSettingsAgreementsRouteImport } from "./routes/_app/settings.agreements";
import { Route as AppSettingsAssistantsRouteImport } from "./routes/_app/settings.assistants";
import { Route as AppSettingsBillingRouteImport } from "./routes/_app/settings.billing";
import { Route as AppSettingsBrandRouteImport } from "./routes/_app/settings.brand";
import { Route as AppSettingsCompanyRouteImport } from "./routes/_app/settings.company";
import { Route as AppSettingsGuardianRouteImport } from "./routes/_app/settings.guardian";
import { Route as AppSettingsKeysRouteImport } from "./routes/_app/settings.keys";
import { Route as AppSettingsNotificationsRouteImport } from "./routes/_app/settings.notifications";
import { Route as AppSettingsProfileRouteImport } from "./routes/_app/settings.profile";
import { Route as AppSettingsSharingRouteImport } from "./routes/_app/settings.sharing";
import { Route as AppSettingsSlackRouteImport } from "./routes/_app/settings.slack";
import { Route as AppSettingsTeamRouteImport } from "./routes/_app/settings.team";
import { Route as AppSettingsTeamsRouteImport } from "./routes/_app/settings.teams";
import { Route as AppThreadsIndexRouteImport } from "./routes/_app/threads.index";
import { Route as AppThreadsThreadIdRouteImport } from "./routes/_app/threads.$threadId";
import { Route as StaffSysadminIndexRouteImport } from "./routes/_staff.sysadmin.index";
import { Route as StaffSysadminAiRouteImport } from "./routes/_staff.sysadmin.ai";
import { Route as StaffSysadminDeletedRouteImport } from "./routes/_staff.sysadmin.deleted";
import { Route as StaffSysadminLogRouteImport } from "./routes/_staff.sysadmin.log";
import { Route as StaffSysadminMoneyRouteImport } from "./routes/_staff.sysadmin.money";
import { Route as StaffSysadminNoticesRouteImport } from "./routes/_staff.sysadmin.notices";
import { Route as StaffSysadminPlansRouteImport } from "./routes/_staff.sysadmin.plans";
import { Route as StaffSysadminProblemsRouteImport } from "./routes/_staff.sysadmin.problems";
import { Route as StaffSysadminReportsRouteImport } from "./routes/_staff.sysadmin.reports";
import { Route as AppSettingsGuardianLogRouteImport } from "./routes/_app/settings.guardian_.log";
import { Route as StaffSysadminCompaniesCompanyIdRouteImport } from "./routes/_staff.sysadmin.companies.$companyId";
import { Route as StaffSysadminRunsIndexRouteImport } from "./routes/_staff.sysadmin.runs.index";
import { Route as StaffSysadminRunsAccessIdIndexRouteImport } from "./routes/_staff.sysadmin.runs.$accessId.index";
import { Route as StaffSysadminRunsAccessIdRunIdRouteImport } from "./routes/_staff.sysadmin.runs.$accessId.$runId";

const AppRoute = AppRouteImport.update({
  id: "/_app",
  getParentRoute: () => rootRouteImport,
} as any);
const StaffRoute = StaffRouteImport.update({
  id: "/_staff",
  getParentRoute: () => rootRouteImport,
} as any);
const ConnectRoute = ConnectRouteImport.update({
  id: "/connect",
  path: "/connect",
  getParentRoute: () => rootRouteImport,
} as any);
const InviteRoute = InviteRouteImport.update({
  id: "/invite",
  path: "/invite",
  getParentRoute: () => rootRouteImport,
} as any);
const SharedRoute = SharedRouteImport.update({
  id: "/shared",
  path: "/shared",
  getParentRoute: () => rootRouteImport,
} as any);
const SignInRoute = SignInRouteImport.update({
  id: "/sign-in",
  path: "/sign-in",
  getParentRoute: () => rootRouteImport,
} as any);
const AppIndexRoute = AppIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppRoute,
} as any);
const AppSplatRoute = AppSplatRouteImport.update({
  id: "/$",
  path: "/$",
  getParentRoute: () => AppRoute,
} as any);
const AppActivityRoute = AppActivityRouteImport.update({
  id: "/activity",
  path: "/activity",
  getParentRoute: () => AppRoute,
} as any);
const AppDataRoute = AppDataRouteImport.update({
  id: "/data",
  path: "/data",
  getParentRoute: () => AppRoute,
} as any);
const AppLearnedRoute = AppLearnedRouteImport.update({
  id: "/learned",
  path: "/learned",
  getParentRoute: () => AppRoute,
} as any);
const AppListsRoute = AppListsRouteImport.update({
  id: "/lists",
  path: "/lists",
  getParentRoute: () => AppRoute,
} as any);
const AppRoutinesRoute = AppRoutinesRouteImport.update({
  id: "/routines",
  path: "/routines",
  getParentRoute: () => AppRoute,
} as any);
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => AppRoute,
} as any);
const AppStaffAccessRoute = AppStaffAccessRouteImport.update({
  id: "/staff-access",
  path: "/staff-access",
  getParentRoute: () => AppRoute,
} as any);
const AppStudyRoute = AppStudyRouteImport.update({
  id: "/study",
  path: "/study",
  getParentRoute: () => AppRoute,
} as any);
const AppTimelineRoute = AppTimelineRouteImport.update({
  id: "/timeline",
  path: "/timeline",
  getParentRoute: () => AppRoute,
} as any);
const AppUnderstandingRoute = AppUnderstandingRouteImport.update({
  id: "/understanding",
  path: "/understanding",
  getParentRoute: () => AppRoute,
} as any);
const CompanyDeleteRoute = CompanyDeleteRouteImport.update({
  id: "/company/delete",
  path: "/company/delete",
  getParentRoute: () => rootRouteImport,
} as any);
const CompanyRestoreRoute = CompanyRestoreRouteImport.update({
  id: "/company/restore",
  path: "/company/restore",
  getParentRoute: () => rootRouteImport,
} as any);
const AppAreasGroupIdRoute = AppAreasGroupIdRouteImport.update({
  id: "/areas/$groupId",
  path: "/areas/$groupId",
  getParentRoute: () => AppRoute,
} as any);
const AppConfirmIndexRoute = AppConfirmIndexRouteImport.update({
  id: "/confirm/",
  path: "/confirm/",
  getParentRoute: () => AppRoute,
} as any);
const AppConfirmRequestIdRoute = AppConfirmRequestIdRouteImport.update({
  id: "/confirm/$requestId",
  path: "/confirm/$requestId",
  getParentRoute: () => AppRoute,
} as any);
const AppConnectPlatformRoute = AppConnectPlatformRouteImport.update({
  id: "/connect/$platform",
  path: "/connect/$platform",
  getParentRoute: () => AppRoute,
} as any);
const AppInsightsIndexRoute = AppInsightsIndexRouteImport.update({
  id: "/insights/",
  path: "/insights/",
  getParentRoute: () => AppRoute,
} as any);
const AppInsightsInsightIdRoute = AppInsightsInsightIdRouteImport.update({
  id: "/insights/$insightId",
  path: "/insights/$insightId",
  getParentRoute: () => AppRoute,
} as any);
const AppInsightsPlaybooksRoute = AppInsightsPlaybooksRouteImport.update({
  id: "/insights/playbooks",
  path: "/insights/playbooks",
  getParentRoute: () => AppRoute,
} as any);
const AppListsIndexRoute = AppListsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppListsRoute,
} as any);
const AppListsListIdRoute = AppListsListIdRouteImport.update({
  id: "/$listId",
  path: "/$listId",
  getParentRoute: () => AppListsRoute,
} as any);
const AppMeasuresIndexRoute = AppMeasuresIndexRouteImport.update({
  id: "/measures/",
  path: "/measures/",
  getParentRoute: () => AppRoute,
} as any);
const AppMeasuresRecipeIdRoute = AppMeasuresRecipeIdRouteImport.update({
  id: "/measures/$recipeId",
  path: "/measures/$recipeId",
  getParentRoute: () => AppRoute,
} as any);
const AppPagesIndexRoute = AppPagesIndexRouteImport.update({
  id: "/pages/",
  path: "/pages/",
  getParentRoute: () => AppRoute,
} as any);
const AppPagesPageIdRoute = AppPagesPageIdRouteImport.update({
  id: "/pages/$pageId",
  path: "/pages/$pageId",
  getParentRoute: () => AppRoute,
} as any);
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppSettingsRoute,
} as any);
const AppSettingsAccessRoute = AppSettingsAccessRouteImport.update({
  id: "/access",
  path: "/access",
  getParentRoute: () => AppSettingsRoute,
} as any);
const AppSettingsAgreementsRoute = AppSettingsAgreementsRouteImport.update({
  id: "/agreements",
  path: "/agreements",
  getParentRoute: () => AppSettingsRoute,
} as any);
const AppSettingsAssistantsRoute = AppSettingsAssistantsRouteImport.update({
  id: "/assistants",
  path: "/assistants",
  getParentRoute: () => AppSettingsRoute,
} as any);
const AppSettingsBillingRoute = AppSettingsBillingRouteImport.update({
  id: "/billing",
  path: "/billing",
  getParentRoute: () => AppSettingsRoute,
} as any);
const AppSettingsBrandRoute = AppSettingsBrandRouteImport.update({
  id: "/brand",
  path: "/brand",
  getParentRoute: () => AppSettingsRoute,
} as any);
const AppSettingsCompanyRoute = AppSettingsCompanyRouteImport.update({
  id: "/company",
  path: "/company",
  getParentRoute: () => AppSettingsRoute,
} as any);
const AppSettingsGuardianRoute = AppSettingsGuardianRouteImport.update({
  id: "/guardian",
  path: "/guardian",
  getParentRoute: () => AppSettingsRoute,
} as any);
const AppSettingsKeysRoute = AppSettingsKeysRouteImport.update({
  id: "/keys",
  path: "/keys",
  getParentRoute: () => AppSettingsRoute,
} as any);
const AppSettingsNotificationsRoute =
  AppSettingsNotificationsRouteImport.update({
    id: "/notifications",
    path: "/notifications",
    getParentRoute: () => AppSettingsRoute,
  } as any);
const AppSettingsProfileRoute = AppSettingsProfileRouteImport.update({
  id: "/profile",
  path: "/profile",
  getParentRoute: () => AppSettingsRoute,
} as any);
const AppSettingsSharingRoute = AppSettingsSharingRouteImport.update({
  id: "/sharing",
  path: "/sharing",
  getParentRoute: () => AppSettingsRoute,
} as any);
const AppSettingsSlackRoute = AppSettingsSlackRouteImport.update({
  id: "/slack",
  path: "/slack",
  getParentRoute: () => AppSettingsRoute,
} as any);
const AppSettingsTeamRoute = AppSettingsTeamRouteImport.update({
  id: "/team",
  path: "/team",
  getParentRoute: () => AppSettingsRoute,
} as any);
const AppSettingsTeamsRoute = AppSettingsTeamsRouteImport.update({
  id: "/teams",
  path: "/teams",
  getParentRoute: () => AppSettingsRoute,
} as any);
const AppThreadsIndexRoute = AppThreadsIndexRouteImport.update({
  id: "/threads/",
  path: "/threads/",
  getParentRoute: () => AppRoute,
} as any);
const AppThreadsThreadIdRoute = AppThreadsThreadIdRouteImport.update({
  id: "/threads/$threadId",
  path: "/threads/$threadId",
  getParentRoute: () => AppRoute,
} as any);
const StaffSysadminIndexRoute = StaffSysadminIndexRouteImport.update({
  id: "/sysadmin/",
  path: "/sysadmin/",
  getParentRoute: () => StaffRoute,
} as any);
const StaffSysadminAiRoute = StaffSysadminAiRouteImport.update({
  id: "/sysadmin/ai",
  path: "/sysadmin/ai",
  getParentRoute: () => StaffRoute,
} as any);
const StaffSysadminDeletedRoute = StaffSysadminDeletedRouteImport.update({
  id: "/sysadmin/deleted",
  path: "/sysadmin/deleted",
  getParentRoute: () => StaffRoute,
} as any);
const StaffSysadminLogRoute = StaffSysadminLogRouteImport.update({
  id: "/sysadmin/log",
  path: "/sysadmin/log",
  getParentRoute: () => StaffRoute,
} as any);
const StaffSysadminMoneyRoute = StaffSysadminMoneyRouteImport.update({
  id: "/sysadmin/money",
  path: "/sysadmin/money",
  getParentRoute: () => StaffRoute,
} as any);
const StaffSysadminNoticesRoute = StaffSysadminNoticesRouteImport.update({
  id: "/sysadmin/notices",
  path: "/sysadmin/notices",
  getParentRoute: () => StaffRoute,
} as any);
const StaffSysadminPlansRoute = StaffSysadminPlansRouteImport.update({
  id: "/sysadmin/plans",
  path: "/sysadmin/plans",
  getParentRoute: () => StaffRoute,
} as any);
const StaffSysadminProblemsRoute = StaffSysadminProblemsRouteImport.update({
  id: "/sysadmin/problems",
  path: "/sysadmin/problems",
  getParentRoute: () => StaffRoute,
} as any);
const StaffSysadminReportsRoute = StaffSysadminReportsRouteImport.update({
  id: "/sysadmin/reports",
  path: "/sysadmin/reports",
  getParentRoute: () => StaffRoute,
} as any);
const AppSettingsGuardianLogRoute = AppSettingsGuardianLogRouteImport.update({
  id: "/guardian_/log",
  path: "/guardian/log",
  getParentRoute: () => AppSettingsRoute,
} as any);
const StaffSysadminCompaniesCompanyIdRoute =
  StaffSysadminCompaniesCompanyIdRouteImport.update({
    id: "/sysadmin/companies/$companyId",
    path: "/sysadmin/companies/$companyId",
    getParentRoute: () => StaffRoute,
  } as any);
const StaffSysadminRunsIndexRoute = StaffSysadminRunsIndexRouteImport.update({
  id: "/sysadmin/runs/",
  path: "/sysadmin/runs/",
  getParentRoute: () => StaffRoute,
} as any);
const StaffSysadminRunsAccessIdIndexRoute =
  StaffSysadminRunsAccessIdIndexRouteImport.update({
    id: "/sysadmin/runs/$accessId/",
    path: "/sysadmin/runs/$accessId/",
    getParentRoute: () => StaffRoute,
  } as any);
const StaffSysadminRunsAccessIdRunIdRoute =
  StaffSysadminRunsAccessIdRunIdRouteImport.update({
    id: "/sysadmin/runs/$accessId/$runId",
    path: "/sysadmin/runs/$accessId/$runId",
    getParentRoute: () => StaffRoute,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof AppIndexRoute;
  "/connect": typeof ConnectRoute;
  "/invite": typeof InviteRoute;
  "/shared": typeof SharedRoute;
  "/sign-in": typeof SignInRoute;
  "/$": typeof AppSplatRoute;
  "/activity": typeof AppActivityRoute;
  "/data": typeof AppDataRoute;
  "/learned": typeof AppLearnedRoute;
  "/lists": typeof AppListsRouteWithChildren;
  "/routines": typeof AppRoutinesRoute;
  "/settings": typeof AppSettingsRouteWithChildren;
  "/staff-access": typeof AppStaffAccessRoute;
  "/study": typeof AppStudyRoute;
  "/timeline": typeof AppTimelineRoute;
  "/understanding": typeof AppUnderstandingRoute;
  "/company/delete": typeof CompanyDeleteRoute;
  "/company/restore": typeof CompanyRestoreRoute;
  "/areas/$groupId": typeof AppAreasGroupIdRoute;
  "/confirm/$requestId": typeof AppConfirmRequestIdRoute;
  "/connect/$platform": typeof AppConnectPlatformRoute;
  "/insights/$insightId": typeof AppInsightsInsightIdRoute;
  "/insights/playbooks": typeof AppInsightsPlaybooksRoute;
  "/lists/$listId": typeof AppListsListIdRoute;
  "/measures/$recipeId": typeof AppMeasuresRecipeIdRoute;
  "/pages/$pageId": typeof AppPagesPageIdRoute;
  "/settings/access": typeof AppSettingsAccessRoute;
  "/settings/agreements": typeof AppSettingsAgreementsRoute;
  "/settings/assistants": typeof AppSettingsAssistantsRoute;
  "/settings/billing": typeof AppSettingsBillingRoute;
  "/settings/brand": typeof AppSettingsBrandRoute;
  "/settings/company": typeof AppSettingsCompanyRoute;
  "/settings/guardian": typeof AppSettingsGuardianRoute;
  "/settings/keys": typeof AppSettingsKeysRoute;
  "/settings/notifications": typeof AppSettingsNotificationsRoute;
  "/settings/profile": typeof AppSettingsProfileRoute;
  "/settings/sharing": typeof AppSettingsSharingRoute;
  "/settings/slack": typeof AppSettingsSlackRoute;
  "/settings/team": typeof AppSettingsTeamRoute;
  "/settings/teams": typeof AppSettingsTeamsRoute;
  "/threads/$threadId": typeof AppThreadsThreadIdRoute;
  "/sysadmin/ai": typeof StaffSysadminAiRoute;
  "/sysadmin/deleted": typeof StaffSysadminDeletedRoute;
  "/sysadmin/log": typeof StaffSysadminLogRoute;
  "/sysadmin/money": typeof StaffSysadminMoneyRoute;
  "/sysadmin/notices": typeof StaffSysadminNoticesRoute;
  "/sysadmin/plans": typeof StaffSysadminPlansRoute;
  "/sysadmin/problems": typeof StaffSysadminProblemsRoute;
  "/sysadmin/reports": typeof StaffSysadminReportsRoute;
  "/confirm/": typeof AppConfirmIndexRoute;
  "/insights/": typeof AppInsightsIndexRoute;
  "/lists/": typeof AppListsIndexRoute;
  "/measures/": typeof AppMeasuresIndexRoute;
  "/pages/": typeof AppPagesIndexRoute;
  "/settings/": typeof AppSettingsIndexRoute;
  "/threads/": typeof AppThreadsIndexRoute;
  "/sysadmin/": typeof StaffSysadminIndexRoute;
  "/settings/guardian/log": typeof AppSettingsGuardianLogRoute;
  "/sysadmin/companies/$companyId": typeof StaffSysadminCompaniesCompanyIdRoute;
  "/sysadmin/runs/": typeof StaffSysadminRunsIndexRoute;
  "/sysadmin/runs/$accessId/$runId": typeof StaffSysadminRunsAccessIdRunIdRoute;
  "/sysadmin/runs/$accessId/": typeof StaffSysadminRunsAccessIdIndexRoute;
}
export interface FileRoutesByTo {
  "/": typeof AppIndexRoute;
  "/connect": typeof ConnectRoute;
  "/invite": typeof InviteRoute;
  "/shared": typeof SharedRoute;
  "/sign-in": typeof SignInRoute;
  "/$": typeof AppSplatRoute;
  "/activity": typeof AppActivityRoute;
  "/data": typeof AppDataRoute;
  "/learned": typeof AppLearnedRoute;
  "/routines": typeof AppRoutinesRoute;
  "/staff-access": typeof AppStaffAccessRoute;
  "/study": typeof AppStudyRoute;
  "/timeline": typeof AppTimelineRoute;
  "/understanding": typeof AppUnderstandingRoute;
  "/company/delete": typeof CompanyDeleteRoute;
  "/company/restore": typeof CompanyRestoreRoute;
  "/areas/$groupId": typeof AppAreasGroupIdRoute;
  "/confirm/$requestId": typeof AppConfirmRequestIdRoute;
  "/connect/$platform": typeof AppConnectPlatformRoute;
  "/insights/$insightId": typeof AppInsightsInsightIdRoute;
  "/insights/playbooks": typeof AppInsightsPlaybooksRoute;
  "/lists/$listId": typeof AppListsListIdRoute;
  "/measures/$recipeId": typeof AppMeasuresRecipeIdRoute;
  "/pages/$pageId": typeof AppPagesPageIdRoute;
  "/settings/access": typeof AppSettingsAccessRoute;
  "/settings/agreements": typeof AppSettingsAgreementsRoute;
  "/settings/assistants": typeof AppSettingsAssistantsRoute;
  "/settings/billing": typeof AppSettingsBillingRoute;
  "/settings/brand": typeof AppSettingsBrandRoute;
  "/settings/company": typeof AppSettingsCompanyRoute;
  "/settings/guardian": typeof AppSettingsGuardianRoute;
  "/settings/keys": typeof AppSettingsKeysRoute;
  "/settings/notifications": typeof AppSettingsNotificationsRoute;
  "/settings/profile": typeof AppSettingsProfileRoute;
  "/settings/sharing": typeof AppSettingsSharingRoute;
  "/settings/slack": typeof AppSettingsSlackRoute;
  "/settings/team": typeof AppSettingsTeamRoute;
  "/settings/teams": typeof AppSettingsTeamsRoute;
  "/threads/$threadId": typeof AppThreadsThreadIdRoute;
  "/sysadmin/ai": typeof StaffSysadminAiRoute;
  "/sysadmin/deleted": typeof StaffSysadminDeletedRoute;
  "/sysadmin/log": typeof StaffSysadminLogRoute;
  "/sysadmin/money": typeof StaffSysadminMoneyRoute;
  "/sysadmin/notices": typeof StaffSysadminNoticesRoute;
  "/sysadmin/plans": typeof StaffSysadminPlansRoute;
  "/sysadmin/problems": typeof StaffSysadminProblemsRoute;
  "/sysadmin/reports": typeof StaffSysadminReportsRoute;
  "/confirm": typeof AppConfirmIndexRoute;
  "/insights": typeof AppInsightsIndexRoute;
  "/lists": typeof AppListsIndexRoute;
  "/measures": typeof AppMeasuresIndexRoute;
  "/pages": typeof AppPagesIndexRoute;
  "/settings": typeof AppSettingsIndexRoute;
  "/threads": typeof AppThreadsIndexRoute;
  "/sysadmin": typeof StaffSysadminIndexRoute;
  "/settings/guardian/log": typeof AppSettingsGuardianLogRoute;
  "/sysadmin/companies/$companyId": typeof StaffSysadminCompaniesCompanyIdRoute;
  "/sysadmin/runs": typeof StaffSysadminRunsIndexRoute;
  "/sysadmin/runs/$accessId/$runId": typeof StaffSysadminRunsAccessIdRunIdRoute;
  "/sysadmin/runs/$accessId": typeof StaffSysadminRunsAccessIdIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/_app": typeof AppRouteWithChildren;
  "/_staff": typeof StaffRouteWithChildren;
  "/connect": typeof ConnectRoute;
  "/invite": typeof InviteRoute;
  "/shared": typeof SharedRoute;
  "/sign-in": typeof SignInRoute;
  "/_app/$": typeof AppSplatRoute;
  "/_app/activity": typeof AppActivityRoute;
  "/_app/data": typeof AppDataRoute;
  "/_app/learned": typeof AppLearnedRoute;
  "/_app/lists": typeof AppListsRouteWithChildren;
  "/_app/routines": typeof AppRoutinesRoute;
  "/_app/settings": typeof AppSettingsRouteWithChildren;
  "/_app/staff-access": typeof AppStaffAccessRoute;
  "/_app/study": typeof AppStudyRoute;
  "/_app/timeline": typeof AppTimelineRoute;
  "/_app/understanding": typeof AppUnderstandingRoute;
  "/company/delete": typeof CompanyDeleteRoute;
  "/company/restore": typeof CompanyRestoreRoute;
  "/_app/": typeof AppIndexRoute;
  "/_app/areas/$groupId": typeof AppAreasGroupIdRoute;
  "/_app/confirm/$requestId": typeof AppConfirmRequestIdRoute;
  "/_app/connect/$platform": typeof AppConnectPlatformRoute;
  "/_app/insights/$insightId": typeof AppInsightsInsightIdRoute;
  "/_app/insights/playbooks": typeof AppInsightsPlaybooksRoute;
  "/_app/lists/$listId": typeof AppListsListIdRoute;
  "/_app/measures/$recipeId": typeof AppMeasuresRecipeIdRoute;
  "/_app/pages/$pageId": typeof AppPagesPageIdRoute;
  "/_app/settings/access": typeof AppSettingsAccessRoute;
  "/_app/settings/agreements": typeof AppSettingsAgreementsRoute;
  "/_app/settings/assistants": typeof AppSettingsAssistantsRoute;
  "/_app/settings/billing": typeof AppSettingsBillingRoute;
  "/_app/settings/brand": typeof AppSettingsBrandRoute;
  "/_app/settings/company": typeof AppSettingsCompanyRoute;
  "/_app/settings/guardian": typeof AppSettingsGuardianRoute;
  "/_app/settings/keys": typeof AppSettingsKeysRoute;
  "/_app/settings/notifications": typeof AppSettingsNotificationsRoute;
  "/_app/settings/profile": typeof AppSettingsProfileRoute;
  "/_app/settings/sharing": typeof AppSettingsSharingRoute;
  "/_app/settings/slack": typeof AppSettingsSlackRoute;
  "/_app/settings/team": typeof AppSettingsTeamRoute;
  "/_app/settings/teams": typeof AppSettingsTeamsRoute;
  "/_app/threads/$threadId": typeof AppThreadsThreadIdRoute;
  "/_staff/sysadmin/ai": typeof StaffSysadminAiRoute;
  "/_staff/sysadmin/deleted": typeof StaffSysadminDeletedRoute;
  "/_staff/sysadmin/log": typeof StaffSysadminLogRoute;
  "/_staff/sysadmin/money": typeof StaffSysadminMoneyRoute;
  "/_staff/sysadmin/notices": typeof StaffSysadminNoticesRoute;
  "/_staff/sysadmin/plans": typeof StaffSysadminPlansRoute;
  "/_staff/sysadmin/problems": typeof StaffSysadminProblemsRoute;
  "/_staff/sysadmin/reports": typeof StaffSysadminReportsRoute;
  "/_app/confirm/": typeof AppConfirmIndexRoute;
  "/_app/insights/": typeof AppInsightsIndexRoute;
  "/_app/lists/": typeof AppListsIndexRoute;
  "/_app/measures/": typeof AppMeasuresIndexRoute;
  "/_app/pages/": typeof AppPagesIndexRoute;
  "/_app/settings/": typeof AppSettingsIndexRoute;
  "/_app/threads/": typeof AppThreadsIndexRoute;
  "/_staff/sysadmin/": typeof StaffSysadminIndexRoute;
  "/_app/settings/guardian_/log": typeof AppSettingsGuardianLogRoute;
  "/_staff/sysadmin/companies/$companyId": typeof StaffSysadminCompaniesCompanyIdRoute;
  "/_staff/sysadmin/runs/": typeof StaffSysadminRunsIndexRoute;
  "/_staff/sysadmin/runs/$accessId/$runId": typeof StaffSysadminRunsAccessIdRunIdRoute;
  "/_staff/sysadmin/runs/$accessId/": typeof StaffSysadminRunsAccessIdIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/connect"
    | "/invite"
    | "/shared"
    | "/sign-in"
    | "/$"
    | "/activity"
    | "/data"
    | "/learned"
    | "/lists"
    | "/routines"
    | "/settings"
    | "/staff-access"
    | "/study"
    | "/timeline"
    | "/understanding"
    | "/company/delete"
    | "/company/restore"
    | "/areas/$groupId"
    | "/confirm/$requestId"
    | "/connect/$platform"
    | "/insights/$insightId"
    | "/insights/playbooks"
    | "/lists/$listId"
    | "/measures/$recipeId"
    | "/pages/$pageId"
    | "/settings/access"
    | "/settings/agreements"
    | "/settings/assistants"
    | "/settings/billing"
    | "/settings/brand"
    | "/settings/company"
    | "/settings/guardian"
    | "/settings/keys"
    | "/settings/notifications"
    | "/settings/profile"
    | "/settings/sharing"
    | "/settings/slack"
    | "/settings/team"
    | "/settings/teams"
    | "/threads/$threadId"
    | "/sysadmin/ai"
    | "/sysadmin/deleted"
    | "/sysadmin/log"
    | "/sysadmin/money"
    | "/sysadmin/notices"
    | "/sysadmin/plans"
    | "/sysadmin/problems"
    | "/sysadmin/reports"
    | "/confirm/"
    | "/insights/"
    | "/lists/"
    | "/measures/"
    | "/pages/"
    | "/settings/"
    | "/threads/"
    | "/sysadmin/"
    | "/settings/guardian/log"
    | "/sysadmin/companies/$companyId"
    | "/sysadmin/runs/"
    | "/sysadmin/runs/$accessId/$runId"
    | "/sysadmin/runs/$accessId/";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/connect"
    | "/invite"
    | "/shared"
    | "/sign-in"
    | "/$"
    | "/activity"
    | "/data"
    | "/learned"
    | "/routines"
    | "/staff-access"
    | "/study"
    | "/timeline"
    | "/understanding"
    | "/company/delete"
    | "/company/restore"
    | "/areas/$groupId"
    | "/confirm/$requestId"
    | "/connect/$platform"
    | "/insights/$insightId"
    | "/insights/playbooks"
    | "/lists/$listId"
    | "/measures/$recipeId"
    | "/pages/$pageId"
    | "/settings/access"
    | "/settings/agreements"
    | "/settings/assistants"
    | "/settings/billing"
    | "/settings/brand"
    | "/settings/company"
    | "/settings/guardian"
    | "/settings/keys"
    | "/settings/notifications"
    | "/settings/profile"
    | "/settings/sharing"
    | "/settings/slack"
    | "/settings/team"
    | "/settings/teams"
    | "/threads/$threadId"
    | "/sysadmin/ai"
    | "/sysadmin/deleted"
    | "/sysadmin/log"
    | "/sysadmin/money"
    | "/sysadmin/notices"
    | "/sysadmin/plans"
    | "/sysadmin/problems"
    | "/sysadmin/reports"
    | "/confirm"
    | "/insights"
    | "/lists"
    | "/measures"
    | "/pages"
    | "/settings"
    | "/threads"
    | "/sysadmin"
    | "/settings/guardian/log"
    | "/sysadmin/companies/$companyId"
    | "/sysadmin/runs"
    | "/sysadmin/runs/$accessId/$runId"
    | "/sysadmin/runs/$accessId";
  id:
    | "__root__"
    | "/_app"
    | "/_staff"
    | "/connect"
    | "/invite"
    | "/shared"
    | "/sign-in"
    | "/_app/$"
    | "/_app/activity"
    | "/_app/data"
    | "/_app/learned"
    | "/_app/lists"
    | "/_app/routines"
    | "/_app/settings"
    | "/_app/staff-access"
    | "/_app/study"
    | "/_app/timeline"
    | "/_app/understanding"
    | "/company/delete"
    | "/company/restore"
    | "/_app/"
    | "/_app/areas/$groupId"
    | "/_app/confirm/$requestId"
    | "/_app/connect/$platform"
    | "/_app/insights/$insightId"
    | "/_app/insights/playbooks"
    | "/_app/lists/$listId"
    | "/_app/measures/$recipeId"
    | "/_app/pages/$pageId"
    | "/_app/settings/access"
    | "/_app/settings/agreements"
    | "/_app/settings/assistants"
    | "/_app/settings/billing"
    | "/_app/settings/brand"
    | "/_app/settings/company"
    | "/_app/settings/guardian"
    | "/_app/settings/keys"
    | "/_app/settings/notifications"
    | "/_app/settings/profile"
    | "/_app/settings/sharing"
    | "/_app/settings/slack"
    | "/_app/settings/team"
    | "/_app/settings/teams"
    | "/_app/threads/$threadId"
    | "/_staff/sysadmin/ai"
    | "/_staff/sysadmin/deleted"
    | "/_staff/sysadmin/log"
    | "/_staff/sysadmin/money"
    | "/_staff/sysadmin/notices"
    | "/_staff/sysadmin/plans"
    | "/_staff/sysadmin/problems"
    | "/_staff/sysadmin/reports"
    | "/_app/confirm/"
    | "/_app/insights/"
    | "/_app/lists/"
    | "/_app/measures/"
    | "/_app/pages/"
    | "/_app/settings/"
    | "/_app/threads/"
    | "/_staff/sysadmin/"
    | "/_app/settings/guardian_/log"
    | "/_staff/sysadmin/companies/$companyId"
    | "/_staff/sysadmin/runs/"
    | "/_staff/sysadmin/runs/$accessId/$runId"
    | "/_staff/sysadmin/runs/$accessId/";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren;
  StaffRoute: typeof StaffRouteWithChildren;
  ConnectRoute: typeof ConnectRoute;
  InviteRoute: typeof InviteRoute;
  SharedRoute: typeof SharedRoute;
  SignInRoute: typeof SignInRoute;
  CompanyDeleteRoute: typeof CompanyDeleteRoute;
  CompanyRestoreRoute: typeof CompanyRestoreRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_app": {
      id: "/_app";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AppRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_staff": {
      id: "/_staff";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof StaffRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/connect": {
      id: "/connect";
      path: "/connect";
      fullPath: "/connect";
      preLoaderRoute: typeof ConnectRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/invite": {
      id: "/invite";
      path: "/invite";
      fullPath: "/invite";
      preLoaderRoute: typeof InviteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/shared": {
      id: "/shared";
      path: "/shared";
      fullPath: "/shared";
      preLoaderRoute: typeof SharedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/sign-in": {
      id: "/sign-in";
      path: "/sign-in";
      fullPath: "/sign-in";
      preLoaderRoute: typeof SignInRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_app/": {
      id: "/_app/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof AppIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/$": {
      id: "/_app/$";
      path: "/$";
      fullPath: "/$";
      preLoaderRoute: typeof AppSplatRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/activity": {
      id: "/_app/activity";
      path: "/activity";
      fullPath: "/activity";
      preLoaderRoute: typeof AppActivityRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/data": {
      id: "/_app/data";
      path: "/data";
      fullPath: "/data";
      preLoaderRoute: typeof AppDataRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/learned": {
      id: "/_app/learned";
      path: "/learned";
      fullPath: "/learned";
      preLoaderRoute: typeof AppLearnedRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/lists": {
      id: "/_app/lists";
      path: "/lists";
      fullPath: "/lists";
      preLoaderRoute: typeof AppListsRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/routines": {
      id: "/_app/routines";
      path: "/routines";
      fullPath: "/routines";
      preLoaderRoute: typeof AppRoutinesRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/settings": {
      id: "/_app/settings";
      path: "/settings";
      fullPath: "/settings";
      preLoaderRoute: typeof AppSettingsRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/staff-access": {
      id: "/_app/staff-access";
      path: "/staff-access";
      fullPath: "/staff-access";
      preLoaderRoute: typeof AppStaffAccessRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/study": {
      id: "/_app/study";
      path: "/study";
      fullPath: "/study";
      preLoaderRoute: typeof AppStudyRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/timeline": {
      id: "/_app/timeline";
      path: "/timeline";
      fullPath: "/timeline";
      preLoaderRoute: typeof AppTimelineRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/understanding": {
      id: "/_app/understanding";
      path: "/understanding";
      fullPath: "/understanding";
      preLoaderRoute: typeof AppUnderstandingRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/company/delete": {
      id: "/company/delete";
      path: "/company/delete";
      fullPath: "/company/delete";
      preLoaderRoute: typeof CompanyDeleteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/company/restore": {
      id: "/company/restore";
      path: "/company/restore";
      fullPath: "/company/restore";
      preLoaderRoute: typeof CompanyRestoreRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_app/areas/$groupId": {
      id: "/_app/areas/$groupId";
      path: "/areas/$groupId";
      fullPath: "/areas/$groupId";
      preLoaderRoute: typeof AppAreasGroupIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/confirm/": {
      id: "/_app/confirm/";
      path: "/confirm";
      fullPath: "/confirm/";
      preLoaderRoute: typeof AppConfirmIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/confirm/$requestId": {
      id: "/_app/confirm/$requestId";
      path: "/confirm/$requestId";
      fullPath: "/confirm/$requestId";
      preLoaderRoute: typeof AppConfirmRequestIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/connect/$platform": {
      id: "/_app/connect/$platform";
      path: "/connect/$platform";
      fullPath: "/connect/$platform";
      preLoaderRoute: typeof AppConnectPlatformRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/insights/": {
      id: "/_app/insights/";
      path: "/insights";
      fullPath: "/insights/";
      preLoaderRoute: typeof AppInsightsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/insights/$insightId": {
      id: "/_app/insights/$insightId";
      path: "/insights/$insightId";
      fullPath: "/insights/$insightId";
      preLoaderRoute: typeof AppInsightsInsightIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/insights/playbooks": {
      id: "/_app/insights/playbooks";
      path: "/insights/playbooks";
      fullPath: "/insights/playbooks";
      preLoaderRoute: typeof AppInsightsPlaybooksRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/lists/": {
      id: "/_app/lists/";
      path: "/";
      fullPath: "/lists/";
      preLoaderRoute: typeof AppListsIndexRouteImport;
      parentRoute: typeof AppListsRoute;
    };
    "/_app/lists/$listId": {
      id: "/_app/lists/$listId";
      path: "/$listId";
      fullPath: "/lists/$listId";
      preLoaderRoute: typeof AppListsListIdRouteImport;
      parentRoute: typeof AppListsRoute;
    };
    "/_app/measures/": {
      id: "/_app/measures/";
      path: "/measures";
      fullPath: "/measures/";
      preLoaderRoute: typeof AppMeasuresIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/measures/$recipeId": {
      id: "/_app/measures/$recipeId";
      path: "/measures/$recipeId";
      fullPath: "/measures/$recipeId";
      preLoaderRoute: typeof AppMeasuresRecipeIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/pages/": {
      id: "/_app/pages/";
      path: "/pages";
      fullPath: "/pages/";
      preLoaderRoute: typeof AppPagesIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/pages/$pageId": {
      id: "/_app/pages/$pageId";
      path: "/pages/$pageId";
      fullPath: "/pages/$pageId";
      preLoaderRoute: typeof AppPagesPageIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/settings/": {
      id: "/_app/settings/";
      path: "/";
      fullPath: "/settings/";
      preLoaderRoute: typeof AppSettingsIndexRouteImport;
      parentRoute: typeof AppSettingsRoute;
    };
    "/_app/settings/access": {
      id: "/_app/settings/access";
      path: "/access";
      fullPath: "/settings/access";
      preLoaderRoute: typeof AppSettingsAccessRouteImport;
      parentRoute: typeof AppSettingsRoute;
    };
    "/_app/settings/agreements": {
      id: "/_app/settings/agreements";
      path: "/agreements";
      fullPath: "/settings/agreements";
      preLoaderRoute: typeof AppSettingsAgreementsRouteImport;
      parentRoute: typeof AppSettingsRoute;
    };
    "/_app/settings/assistants": {
      id: "/_app/settings/assistants";
      path: "/assistants";
      fullPath: "/settings/assistants";
      preLoaderRoute: typeof AppSettingsAssistantsRouteImport;
      parentRoute: typeof AppSettingsRoute;
    };
    "/_app/settings/billing": {
      id: "/_app/settings/billing";
      path: "/billing";
      fullPath: "/settings/billing";
      preLoaderRoute: typeof AppSettingsBillingRouteImport;
      parentRoute: typeof AppSettingsRoute;
    };
    "/_app/settings/brand": {
      id: "/_app/settings/brand";
      path: "/brand";
      fullPath: "/settings/brand";
      preLoaderRoute: typeof AppSettingsBrandRouteImport;
      parentRoute: typeof AppSettingsRoute;
    };
    "/_app/settings/company": {
      id: "/_app/settings/company";
      path: "/company";
      fullPath: "/settings/company";
      preLoaderRoute: typeof AppSettingsCompanyRouteImport;
      parentRoute: typeof AppSettingsRoute;
    };
    "/_app/settings/guardian": {
      id: "/_app/settings/guardian";
      path: "/guardian";
      fullPath: "/settings/guardian";
      preLoaderRoute: typeof AppSettingsGuardianRouteImport;
      parentRoute: typeof AppSettingsRoute;
    };
    "/_app/settings/keys": {
      id: "/_app/settings/keys";
      path: "/keys";
      fullPath: "/settings/keys";
      preLoaderRoute: typeof AppSettingsKeysRouteImport;
      parentRoute: typeof AppSettingsRoute;
    };
    "/_app/settings/notifications": {
      id: "/_app/settings/notifications";
      path: "/notifications";
      fullPath: "/settings/notifications";
      preLoaderRoute: typeof AppSettingsNotificationsRouteImport;
      parentRoute: typeof AppSettingsRoute;
    };
    "/_app/settings/profile": {
      id: "/_app/settings/profile";
      path: "/profile";
      fullPath: "/settings/profile";
      preLoaderRoute: typeof AppSettingsProfileRouteImport;
      parentRoute: typeof AppSettingsRoute;
    };
    "/_app/settings/sharing": {
      id: "/_app/settings/sharing";
      path: "/sharing";
      fullPath: "/settings/sharing";
      preLoaderRoute: typeof AppSettingsSharingRouteImport;
      parentRoute: typeof AppSettingsRoute;
    };
    "/_app/settings/slack": {
      id: "/_app/settings/slack";
      path: "/slack";
      fullPath: "/settings/slack";
      preLoaderRoute: typeof AppSettingsSlackRouteImport;
      parentRoute: typeof AppSettingsRoute;
    };
    "/_app/settings/team": {
      id: "/_app/settings/team";
      path: "/team";
      fullPath: "/settings/team";
      preLoaderRoute: typeof AppSettingsTeamRouteImport;
      parentRoute: typeof AppSettingsRoute;
    };
    "/_app/settings/teams": {
      id: "/_app/settings/teams";
      path: "/teams";
      fullPath: "/settings/teams";
      preLoaderRoute: typeof AppSettingsTeamsRouteImport;
      parentRoute: typeof AppSettingsRoute;
    };
    "/_app/threads/": {
      id: "/_app/threads/";
      path: "/threads";
      fullPath: "/threads/";
      preLoaderRoute: typeof AppThreadsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/threads/$threadId": {
      id: "/_app/threads/$threadId";
      path: "/threads/$threadId";
      fullPath: "/threads/$threadId";
      preLoaderRoute: typeof AppThreadsThreadIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_staff/sysadmin/": {
      id: "/_staff/sysadmin/";
      path: "/sysadmin";
      fullPath: "/sysadmin/";
      preLoaderRoute: typeof StaffSysadminIndexRouteImport;
      parentRoute: typeof StaffRoute;
    };
    "/_staff/sysadmin/ai": {
      id: "/_staff/sysadmin/ai";
      path: "/sysadmin/ai";
      fullPath: "/sysadmin/ai";
      preLoaderRoute: typeof StaffSysadminAiRouteImport;
      parentRoute: typeof StaffRoute;
    };
    "/_staff/sysadmin/deleted": {
      id: "/_staff/sysadmin/deleted";
      path: "/sysadmin/deleted";
      fullPath: "/sysadmin/deleted";
      preLoaderRoute: typeof StaffSysadminDeletedRouteImport;
      parentRoute: typeof StaffRoute;
    };
    "/_staff/sysadmin/log": {
      id: "/_staff/sysadmin/log";
      path: "/sysadmin/log";
      fullPath: "/sysadmin/log";
      preLoaderRoute: typeof StaffSysadminLogRouteImport;
      parentRoute: typeof StaffRoute;
    };
    "/_staff/sysadmin/money": {
      id: "/_staff/sysadmin/money";
      path: "/sysadmin/money";
      fullPath: "/sysadmin/money";
      preLoaderRoute: typeof StaffSysadminMoneyRouteImport;
      parentRoute: typeof StaffRoute;
    };
    "/_staff/sysadmin/notices": {
      id: "/_staff/sysadmin/notices";
      path: "/sysadmin/notices";
      fullPath: "/sysadmin/notices";
      preLoaderRoute: typeof StaffSysadminNoticesRouteImport;
      parentRoute: typeof StaffRoute;
    };
    "/_staff/sysadmin/plans": {
      id: "/_staff/sysadmin/plans";
      path: "/sysadmin/plans";
      fullPath: "/sysadmin/plans";
      preLoaderRoute: typeof StaffSysadminPlansRouteImport;
      parentRoute: typeof StaffRoute;
    };
    "/_staff/sysadmin/problems": {
      id: "/_staff/sysadmin/problems";
      path: "/sysadmin/problems";
      fullPath: "/sysadmin/problems";
      preLoaderRoute: typeof StaffSysadminProblemsRouteImport;
      parentRoute: typeof StaffRoute;
    };
    "/_staff/sysadmin/reports": {
      id: "/_staff/sysadmin/reports";
      path: "/sysadmin/reports";
      fullPath: "/sysadmin/reports";
      preLoaderRoute: typeof StaffSysadminReportsRouteImport;
      parentRoute: typeof StaffRoute;
    };
    "/_app/settings/guardian_/log": {
      id: "/_app/settings/guardian_/log";
      path: "/guardian/log";
      fullPath: "/settings/guardian/log";
      preLoaderRoute: typeof AppSettingsGuardianLogRouteImport;
      parentRoute: typeof AppSettingsRoute;
    };
    "/_staff/sysadmin/companies/$companyId": {
      id: "/_staff/sysadmin/companies/$companyId";
      path: "/sysadmin/companies/$companyId";
      fullPath: "/sysadmin/companies/$companyId";
      preLoaderRoute: typeof StaffSysadminCompaniesCompanyIdRouteImport;
      parentRoute: typeof StaffRoute;
    };
    "/_staff/sysadmin/runs/": {
      id: "/_staff/sysadmin/runs/";
      path: "/sysadmin/runs";
      fullPath: "/sysadmin/runs/";
      preLoaderRoute: typeof StaffSysadminRunsIndexRouteImport;
      parentRoute: typeof StaffRoute;
    };
    "/_staff/sysadmin/runs/$accessId/": {
      id: "/_staff/sysadmin/runs/$accessId/";
      path: "/sysadmin/runs/$accessId";
      fullPath: "/sysadmin/runs/$accessId/";
      preLoaderRoute: typeof StaffSysadminRunsAccessIdIndexRouteImport;
      parentRoute: typeof StaffRoute;
    };
    "/_staff/sysadmin/runs/$accessId/$runId": {
      id: "/_staff/sysadmin/runs/$accessId/$runId";
      path: "/sysadmin/runs/$accessId/$runId";
      fullPath: "/sysadmin/runs/$accessId/$runId";
      preLoaderRoute: typeof StaffSysadminRunsAccessIdRunIdRouteImport;
      parentRoute: typeof StaffRoute;
    };
  }
}

interface AppListsRouteChildren {
  AppListsListIdRoute: typeof AppListsListIdRoute;
  AppListsIndexRoute: typeof AppListsIndexRoute;
}

const AppListsRouteChildren: AppListsRouteChildren = {
  AppListsListIdRoute: AppListsListIdRoute,
  AppListsIndexRoute: AppListsIndexRoute,
};

const AppListsRouteWithChildren = AppListsRoute._addFileChildren(
  AppListsRouteChildren,
);

interface AppSettingsRouteChildren {
  AppSettingsAccessRoute: typeof AppSettingsAccessRoute;
  AppSettingsAgreementsRoute: typeof AppSettingsAgreementsRoute;
  AppSettingsAssistantsRoute: typeof AppSettingsAssistantsRoute;
  AppSettingsBillingRoute: typeof AppSettingsBillingRoute;
  AppSettingsBrandRoute: typeof AppSettingsBrandRoute;
  AppSettingsCompanyRoute: typeof AppSettingsCompanyRoute;
  AppSettingsGuardianRoute: typeof AppSettingsGuardianRoute;
  AppSettingsKeysRoute: typeof AppSettingsKeysRoute;
  AppSettingsNotificationsRoute: typeof AppSettingsNotificationsRoute;
  AppSettingsProfileRoute: typeof AppSettingsProfileRoute;
  AppSettingsSharingRoute: typeof AppSettingsSharingRoute;
  AppSettingsSlackRoute: typeof AppSettingsSlackRoute;
  AppSettingsTeamRoute: typeof AppSettingsTeamRoute;
  AppSettingsTeamsRoute: typeof AppSettingsTeamsRoute;
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute;
  AppSettingsGuardianLogRoute: typeof AppSettingsGuardianLogRoute;
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsAccessRoute: AppSettingsAccessRoute,
  AppSettingsAgreementsRoute: AppSettingsAgreementsRoute,
  AppSettingsAssistantsRoute: AppSettingsAssistantsRoute,
  AppSettingsBillingRoute: AppSettingsBillingRoute,
  AppSettingsBrandRoute: AppSettingsBrandRoute,
  AppSettingsCompanyRoute: AppSettingsCompanyRoute,
  AppSettingsGuardianRoute: AppSettingsGuardianRoute,
  AppSettingsKeysRoute: AppSettingsKeysRoute,
  AppSettingsNotificationsRoute: AppSettingsNotificationsRoute,
  AppSettingsProfileRoute: AppSettingsProfileRoute,
  AppSettingsSharingRoute: AppSettingsSharingRoute,
  AppSettingsSlackRoute: AppSettingsSlackRoute,
  AppSettingsTeamRoute: AppSettingsTeamRoute,
  AppSettingsTeamsRoute: AppSettingsTeamsRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
  AppSettingsGuardianLogRoute: AppSettingsGuardianLogRoute,
};

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
);

interface AppRouteChildren {
  AppSplatRoute: typeof AppSplatRoute;
  AppActivityRoute: typeof AppActivityRoute;
  AppDataRoute: typeof AppDataRoute;
  AppLearnedRoute: typeof AppLearnedRoute;
  AppListsRoute: typeof AppListsRouteWithChildren;
  AppRoutinesRoute: typeof AppRoutinesRoute;
  AppSettingsRoute: typeof AppSettingsRouteWithChildren;
  AppStaffAccessRoute: typeof AppStaffAccessRoute;
  AppStudyRoute: typeof AppStudyRoute;
  AppTimelineRoute: typeof AppTimelineRoute;
  AppUnderstandingRoute: typeof AppUnderstandingRoute;
  AppIndexRoute: typeof AppIndexRoute;
  AppAreasGroupIdRoute: typeof AppAreasGroupIdRoute;
  AppConfirmRequestIdRoute: typeof AppConfirmRequestIdRoute;
  AppConnectPlatformRoute: typeof AppConnectPlatformRoute;
  AppInsightsInsightIdRoute: typeof AppInsightsInsightIdRoute;
  AppInsightsPlaybooksRoute: typeof AppInsightsPlaybooksRoute;
  AppMeasuresRecipeIdRoute: typeof AppMeasuresRecipeIdRoute;
  AppPagesPageIdRoute: typeof AppPagesPageIdRoute;
  AppThreadsThreadIdRoute: typeof AppThreadsThreadIdRoute;
  AppConfirmIndexRoute: typeof AppConfirmIndexRoute;
  AppInsightsIndexRoute: typeof AppInsightsIndexRoute;
  AppMeasuresIndexRoute: typeof AppMeasuresIndexRoute;
  AppPagesIndexRoute: typeof AppPagesIndexRoute;
  AppThreadsIndexRoute: typeof AppThreadsIndexRoute;
}

const AppRouteChildren: AppRouteChildren = {
  AppSplatRoute: AppSplatRoute,
  AppActivityRoute: AppActivityRoute,
  AppDataRoute: AppDataRoute,
  AppLearnedRoute: AppLearnedRoute,
  AppListsRoute: AppListsRouteWithChildren,
  AppRoutinesRoute: AppRoutinesRoute,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppStaffAccessRoute: AppStaffAccessRoute,
  AppStudyRoute: AppStudyRoute,
  AppTimelineRoute: AppTimelineRoute,
  AppUnderstandingRoute: AppUnderstandingRoute,
  AppIndexRoute: AppIndexRoute,
  AppAreasGroupIdRoute: AppAreasGroupIdRoute,
  AppConfirmRequestIdRoute: AppConfirmRequestIdRoute,
  AppConnectPlatformRoute: AppConnectPlatformRoute,
  AppInsightsInsightIdRoute: AppInsightsInsightIdRoute,
  AppInsightsPlaybooksRoute: AppInsightsPlaybooksRoute,
  AppMeasuresRecipeIdRoute: AppMeasuresRecipeIdRoute,
  AppPagesPageIdRoute: AppPagesPageIdRoute,
  AppThreadsThreadIdRoute: AppThreadsThreadIdRoute,
  AppConfirmIndexRoute: AppConfirmIndexRoute,
  AppInsightsIndexRoute: AppInsightsIndexRoute,
  AppMeasuresIndexRoute: AppMeasuresIndexRoute,
  AppPagesIndexRoute: AppPagesIndexRoute,
  AppThreadsIndexRoute: AppThreadsIndexRoute,
};

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren);

interface StaffRouteChildren {
  StaffSysadminAiRoute: typeof StaffSysadminAiRoute;
  StaffSysadminDeletedRoute: typeof StaffSysadminDeletedRoute;
  StaffSysadminLogRoute: typeof StaffSysadminLogRoute;
  StaffSysadminMoneyRoute: typeof StaffSysadminMoneyRoute;
  StaffSysadminNoticesRoute: typeof StaffSysadminNoticesRoute;
  StaffSysadminPlansRoute: typeof StaffSysadminPlansRoute;
  StaffSysadminProblemsRoute: typeof StaffSysadminProblemsRoute;
  StaffSysadminReportsRoute: typeof StaffSysadminReportsRoute;
  StaffSysadminIndexRoute: typeof StaffSysadminIndexRoute;
  StaffSysadminCompaniesCompanyIdRoute: typeof StaffSysadminCompaniesCompanyIdRoute;
  StaffSysadminRunsIndexRoute: typeof StaffSysadminRunsIndexRoute;
  StaffSysadminRunsAccessIdRunIdRoute: typeof StaffSysadminRunsAccessIdRunIdRoute;
  StaffSysadminRunsAccessIdIndexRoute: typeof StaffSysadminRunsAccessIdIndexRoute;
}

const StaffRouteChildren: StaffRouteChildren = {
  StaffSysadminAiRoute: StaffSysadminAiRoute,
  StaffSysadminDeletedRoute: StaffSysadminDeletedRoute,
  StaffSysadminLogRoute: StaffSysadminLogRoute,
  StaffSysadminMoneyRoute: StaffSysadminMoneyRoute,
  StaffSysadminNoticesRoute: StaffSysadminNoticesRoute,
  StaffSysadminPlansRoute: StaffSysadminPlansRoute,
  StaffSysadminProblemsRoute: StaffSysadminProblemsRoute,
  StaffSysadminReportsRoute: StaffSysadminReportsRoute,
  StaffSysadminIndexRoute: StaffSysadminIndexRoute,
  StaffSysadminCompaniesCompanyIdRoute: StaffSysadminCompaniesCompanyIdRoute,
  StaffSysadminRunsIndexRoute: StaffSysadminRunsIndexRoute,
  StaffSysadminRunsAccessIdRunIdRoute: StaffSysadminRunsAccessIdRunIdRoute,
  StaffSysadminRunsAccessIdIndexRoute: StaffSysadminRunsAccessIdIndexRoute,
};

const StaffRouteWithChildren = StaffRoute._addFileChildren(StaffRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  StaffRoute: StaffRouteWithChildren,
  ConnectRoute: ConnectRoute,
  InviteRoute: InviteRoute,
  SharedRoute: SharedRoute,
  SignInRoute: SignInRoute,
  CompanyDeleteRoute: CompanyDeleteRoute,
  CompanyRestoreRoute: CompanyRestoreRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
